import PdmiCredentials from './PdmiCredentials';

export default PdmiCredentials;



// WEBPACK FOOTER //
// ./src/pages/PdmiCredentials/index.jsx